/* 新增编学号规则 */
import React, { Component } from "react";
import { Row, Col, Form, Input, Switch, Radio, InputNumber, message, Button } from 'antd';
import Scrollbars from '../custom/Scrollbars';
import DragTable from '../custom/DragTable';
import NHFetch from '../../utils/NHFetch'
import css from './index.css';
import getSize from "../../utils/getSize";
import NHMultiSelect from "../common/NHMultiSelect";
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const gzmc = "zhxg_yxxt_xhgz";
class AddStuIdRuleModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            generateRuleList: [], // 生成规则
            sortRuleList: [], // 排序规则
            modelTypes: { add: 'add', edit: 'edit', onlyView: 'onlyView' },
            modelType: props.modelType,
            pkid: "",
            lshczbz :[]
        }
    }

    componentDidMount() {
        this.getBxhDetail();
    }
    getBxhDetail() { 
        NHFetch('/bxhgzgl/getDetail/' + gzmc, 'GET').then(res => {
            if (res && res.code && res.code === 200) {
                this.setState ({
                    gzmc: res.data.gzmc,
                    sfgx: res.data.sfgx,
                    zdysz: res.data.zdysz,
                    pkid: res.data.pkid,
                });
                this.setInit(res.data);
            }
        })
    }

    //设置默认值，或者详情
    setInit(data) {
        const pxgzs = data.pxgzPOS; 
        if (pxgzs) {
            pxgzs.sort((a, b) => { return a.XH - b.XH })
            this.setState({
                sortRuleList: pxgzs.map((item, index) => {
                    item.bxhxmc = item.bxhxmc
                    item.bxhxdm = item.bxhxdm
                    item.zt = item.zt === '1';
                    item.pkid = item.pkid;
                    item.key = index
                    return item
                })
            });
        }
        const scgzs = data.scgzPOS;
        if (scgzs) {
            scgzs.sort((a, b) => { return a.xh - b.xh })
            this.setState({
                generateRuleList: scgzs.map((item, index) => {
                    let o = {};
                    o.gzm = item.gzm;
                    o.gzzlx = item.gzzlx;
                    o.scmbid = item.scmbid;
                    if (o.gzzlx === "0") {
                        o.gzz = item.gzz
                    } else if (o.gzzlx === "2") { 
                        if(item.gzz){
                            o.ws = item.gzz.split('-')[0];
                            o.czbz =  item.gzz.split('-')[1] ? item.gzz.split('-')[1].split(',') :[];
                          
                        }
                    } else if (o.gzzlx === "1") {
                        // 将后端数据进行切割处理 
                        if (item.gzz) {
                            o.start = Number(item.gzz.split(',')[0])//起始位
                            o.totalLength = Number(item.gzz.split(',')[1])//总长度
                        }
                        o.gzz = item.gzz
                    }
                    o.zt = item.zt === '1';
                    o.pkid = item.pkid;
                    o.key = index
                    return o
                })
            });
        }
    }

    // 规则变化
    onRuleChange = (record, index, value, site) => {
        //常量
        if (record.gzzlx === '0') {
            record.gzz = value.target.value;
            let generateRuleList = this.state.generateRuleList;
            generateRuleList[index] = record;
            this.setState({ generateRuleList: generateRuleList })
        }
        //截取代码
        else if (record.gzzlx === '1') {
            if (site == 'start') {
                record.start = value;
            }
            if (site == 'length') {
                record.totalLength = value;
            }
            record.gzz = record.start + ',' + record.totalLength;
            let generateRuleList = this.state.generateRuleList;
            generateRuleList[index] = record;
            this.setState({ generateRuleList: generateRuleList })
        }
        //流水号
        else if (record.gzzlx === '2') { 
            if (site == 'ws') {
                record.ws = value;
            }
            if (site == 'czbz') {
                console.log("删除后值",value)
                record.czbz =  value.toString();
                record.czbzs = '-' +value.toString();
            }
            if(record.ws == null){
                record.gzz = null;
            }else{ 
                record.gzz = record.ws +  record.czbzs;
            }
           
            let generateRuleList = this.state.generateRuleList;
            generateRuleList[index] = record;
            this.setState({ generateRuleList: generateRuleList })
        } else {

        }
    }
    //编学号规则table拖拉
    onStuIdTableChange = (data) => {
        this.setState({
            generateRuleList: data.map((item, index) => {
                item.xh = index + 1
                return item
            })
        })
    }

    //排序规则table拖拉
    onClassRuleTableChange = (data) => {
        this.setState({
            sortRuleList: data.map((item, index) => {
                item.xh = index + 1
                return item
            })
        })
    }


    // 添加编学号规则
    onStuIDRuleSubmit = () => { 
        let generateRuleList = JSON.parse(JSON.stringify(this.state.generateRuleList));
        let sortRuleList = JSON.parse(JSON.stringify(this.state.sortRuleList));
        //判断常量类型是否为空
        for (let obj of generateRuleList) {
            if (obj.gzzlx === '0' && obj.zt) {
                if (!obj.gzz || obj.gzz === '') {
                    message.error('启用的' + obj.gzm + '不能为空！');
                    return;
                }
            }
            if (obj.gzzlx === '2' && obj.zt) { 
                console.log("保存值：",obj.gzz)
                if (!obj.gzz || obj.gzz === '' || obj.gzz.split('-')[1] == null) {
                    message.error('流水号位数和重置标准不能为空！');
                    return;
                }
            }
        }
        generateRuleList = generateRuleList.map(item => {
            item.zt = item.zt ? '1' : '0'
            return item
        });
        let hasEnablePxgz = false;
        sortRuleList = sortRuleList.map(item => {
            hasEnablePxgz = hasEnablePxgz || item.zt;
            item.zt = item.zt ? '1' : '0'
            return item
        });
        if (!hasEnablePxgz) {
            message.error('必须选择一项排序规则！');
            return;
        }
        let params = Object.assign({ gzmc: gzmc }, { pxgzPOS: sortRuleList, scgzPOS: generateRuleList, sfgx: '1' }) 
        params.pkid = this.state.pkid; 
        NHFetch('/bxhgzgl/bxh/createOrUpdate', 'POST', params).then(res => {
            if (res && res.code && res.code === 200) {
                message.success("操作成功！");
            }
        })
    }


    render() {
        const isOnlyView = this.state.modelTypes.onlyView === this.state.modelType;
        const columnsGenerate = [
            {
                title: '条件',
                dataIndex: 'gzm',
                key: 'gzm',
                width: '15%',
                align: 'center'
            },
            {
                title: '开关',
                dataIndex: 'zt',
                key: 'zt',
                align: 'center',
                width: '15%',
                render: (text, record, index) => {
                    return <Switch checked={text} disabled={record.gzzlx === '2' ? true : isOnlyView} onChange={(flag) => {
                        record.zt = flag;
                        let generateRuleList = this.state.generateRuleList;
                        generateRuleList[index] = record;
                        this.setState({ generateRuleList: generateRuleList })
                    }} />
                }
            },
            {
                title: '规则',
                dataIndex: 'rule',
                key: 'rule',
                width: '30%',
                align: 'center',
                render: (text, record, index) => {
                    //常量
                    if (record.gzzlx === '0') {
                        return <Row>
                            <Col span={5}></Col>
                            <Col span={14}>
                                <Input disabled={isOnlyView} style={{ width: '100%' }} value={record.gzz} onChange={(value) => { this.onRuleChange(record, index, value) }}></Input>
                            </Col>
                            <Col span={5}></Col>
                        </Row>
                    }
                    //截取代码
                    else if (record.gzzlx === '1') {
                        return <Row>
                            <Col span={3}></Col>
                            <Col span={9}>
                                <label>起始位 </label>
                                <InputNumber
                                    disabled={isOnlyView}
                                    style={{ width: '60%' }}
                                    precision={0}
                                    min={1}
                                    value={record.start}
                                    onChange={(value) => { this.onRuleChange(record, index, value, 'start') }} />
                            </Col>
                            <Col span={9}>

                                <label>总长度 </label>
                                <InputNumber
                                    disabled={isOnlyView}
                                    style={{ width: '60%' }}
                                    precision={0}
                                    min={1}
                                    value={record.totalLength}
                                    onChange={(value) => { this.onRuleChange(record, index, value, 'length') }} />
                            </Col>
                            <Col span={3}></Col>
                        </Row>
                    }
                    //流水号
                    else if (record.gzzlx === '2') { 
                        return <Row> 
                            <Col span={3}></Col>
                            <Col span={9}>
                                <label>位数 </label>
                                <InputNumber
                                    disabled={isOnlyView}
                                    style={{ width: '60%' }}
                                    precision={0}
                                    min={2}
                                    value={record.ws}
                                    onChange={(value) => { this.onRuleChange(record, index, value, 'ws') }}></InputNumber>
                            </Col>
                            
                            <Col span={3}>
                                <label>重置标准 </label>
                                </Col>
                                <Col span={9}>
                                <NHMultiSelect
                                    style={{ width: '100%' }}
                                    sign={"zhxg_yxxt_bchjzdbxh_lshczbz"} 
                                   // value={typeof record.czbz === "string"  ? record.czbz.split(","):record.czbz}
                                    value={record.czbz !=null && record.czbz !="" && record.czbz !=undefined? typeof record.czbz === "string"  ? record.czbz.split(","):record.czbz:[]}
                                    onChange={(value) => { this.onRuleChange(record, index, value, 'czbz') }}></NHMultiSelect>
                            </Col>
                    
                        </Row>
                    }
                    //替换代码
                    else if (record.gzzlx === '3') {
                        return <Row><Col span={24}>自定义规则</Col></Row>
                    }
                    //系统参数
                    else if (record.gzzlx === '4') {
                        return <Row><Col span={24}>系统配置</Col></Row>
                    }
                }
            }
        ];
        const columnsSort = [
            {
                title: '条件',
                dataIndex: 'bxhxmc',
                key: 'bxhxmc',
                width: '15%',
                align: 'center'
            },
            {
                title: '开关',
                dataIndex: 'zt',
                key: 'zt',
                align: 'center',
                width: '15%',
                render: (text, record, index) => {
                    return <Switch checked={text} disabled={isOnlyView} onChange={(flag) => {
                        record.zt = flag;
                        let sortRuleList = this.state.sortRuleList;
                        sortRuleList[index] = record;
                        this.setState({ sortRuleList: sortRuleList })
                    }} />
                }
            }
        ]; //
        return (
            <div className={css.main_right_content}  >
                <Row>
                    <Col span={23}>
                    </Col>
                    <Col span={1}>
                        <Button type="primary" onClick={this.onStuIDRuleSubmit}> 保存</Button>
                    </Col>
                </Row>
                <Form style={{ padding: '0 20px' }}>
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={2}></Col>
                        <Col span={10}>
                        </Col>
                    </Row>

                    <Row style={{ textAlign: 'center' }}>
                        <font color="black" style={{ fontSize: '20px' }}>生成规则（上下拖动可调整规则顺序）</font>
                    </Row>
                    <Row style={{ textAlign: 'center' }}>
                        <font color="red">说明：起始位从第1位开始，长度最少为1位</font>
                    </Row>
                    <Row style={{ textAlign: 'center' }}> 
                        <font color="red">排序规则至少设置一项</font>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <DragTable
                                disabled={isOnlyView}
                                onChange={this.onStuIdTableChange}
                                tableOption={{
                                    columns: columnsGenerate,
                                    dataSource: this.state.generateRuleList,
                                    bordered: true,
                                    pagination: false,
                                }}
                            />
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row style={{ textAlign: 'center' }}>
                        <font color="black" style={{ fontSize: '20px' }}>排序规则（上下拖动可调整规则顺序）</font>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <DragTable
                                disabled={isOnlyView}
                                onChange={this.onClassRuleTableChange}
                                tableOption={{
                                    columns: columnsSort,
                                    dataSource: this.state.sortRuleList,
                                    bordered: true,
                                    pagination: false,
                                }}
                            />
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                </Form>

                <style jsx="true" global="true">
                        {`
                           
                        .ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content { 
                            overflow-x: clip;
                        
                        }
                             
                        `}
                    </style>

            </div>
        )
    }
}

const EditXhRuleManagement = Form.create()(AddStuIdRuleModal);
export default EditXhRuleManagement


// WEBPACK FOOTER //
// ./components/editXhRuleManagement/index.js